import React, { useState } from 'react' 
import styled from '@emotion/styled/macro'
import { Link } from 'gatsby'
import { useCommonItemsQuery } from '../../hooks/use-common-items-query'
import { Theme2, Device } from "../Layout"
import { Phone, Logo } from "../SVGs"
import { NavMobile } from "../NavMobile"
import { Modal } from '../Modal'
import { HomeFormContainer } from '../HomeFormContainer'

const TopBarMobile = styled.button`
appearance: none;
display: block;
border: none;
width: 100%;
background-color: ${Theme2.colors.tertiary};
padding: 25px 0;
text-align: center;

p{
    color: ${Theme2.colors.dark1};
    background-color: ${Theme2.colors.light2};
    padding: 10px 20px;
    font-size: 16px;
font-weight: 500;

text-transform: uppercase;
letter-spacing: 2px;
display: inline;
}

h5{
    color: #FFFFFF;
    background-color: ${Theme2.colors.tertiary};
    font-size: 16px;
    margin-top: 25px;
font-weight: 500;

text-transform: uppercase;
}

&:hover{
    cursor: pointer;
}
`
const MenuLogoCall = styled.div`
display: grid;
grid-template-columns: 20% 50% 20%;
grid-column-gap: 5%;
align-items: center;
justify-content: space-around;
padding: 15px;
box-sizing: border-box;
background-color: ${Theme2.colors.light};

svg{
    max-width: 100%;
}
.Phone{
    max-width: 60%;
}
`
const HeaderContainer = styled.div`
position: sticky;
    top: 0;
    z-index: 3;
    @media ${Device.lg}{
    display: none;
}
`

const HeaderMobile = () =>{
    const [modalOpen, setModalOpen] = useState(false);
    const modalContent = <HomeFormContainer />

    const { commonItemsTopBarTextMobile, commonItemsOffices } = useCommonItemsQuery()
    const tel = "tel:"
    const phoneNumber = commonItemsOffices[0].commonItemsPhone
    const phoneNumberHref = tel+phoneNumber
    return(
        <>
        <HeaderContainer>
      
        <TopBarMobile
        onClick={() => setModalOpen(true)}
        >
            <p>
            {commonItemsTopBarTextMobile}
            </p><br/>
            <h5>Se hablamos español</h5>
            
        </TopBarMobile>
       
        <MenuLogoCall>
        <NavMobile />
                <Link to="/">
                <Logo />
                </Link>
                
<a href={phoneNumberHref}>
<Phone />
</a>

        </MenuLogoCall>
        </HeaderContainer>
        <Modal onClose={() => setModalOpen(false)} modalOpen={modalOpen} modalContent={modalContent}  />
        </>
    )
}
export default HeaderMobile